import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DECORATOR__class_serialization_tested } from '../_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../_base/DECORATOR__class_serialization_tested_for_hash';
import { FIELD_PRIMITIVE__int } from './FIELD_PRIMITIVE__int';

//todo: make boolean param to use grid2d dimension as enum
@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD_PRIMITIVE__int_image_side extends FIELD_PRIMITIVE__int {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_PRIMITIVE_INT_IMAGE_SIDE;

  /*
   * PROPERTIES
   */

  /*
   * METHODS
   */
}
